// extracted by mini-css-extract-plugin
export default {"title":"Confirm_title__XJKlu","info":"Confirm_info__E1IVg","variants":"Confirm_variants__z-atF","radio":"Confirm_radio__U+kcn","button":"Confirm_button__QJUSb"};